// src/graphql/mutations/setAlertEndpoints.js
import { gql } from '@apollo/client';

export const SET_ALERT_ENDPOINTS = gql`
  mutation setAlertEndpoints($system_id: String!, $alert_endpoints: [AlertEndpointInput!]!) {
    setAlertEndpoints(system_id: $system_id, alert_endpoints: $alert_endpoints) {
      result
    }
  }
`;

